'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherEdit2 } from '@subframe/core';
import type { ReactNode } from 'react';
import type { UseNotificacaoSelfReturn } from '../hooks';
import { AvisoFunil } from './AvisoFunil';
import { WizardFooter } from './WizardFooter';
import { WizardHeader } from './WizardHeader';
interface RevisaoScreenProps {
  vm: UseNotificacaoSelfReturn;
}
interface BlocoProps {
  titulo: string;
  onEditar: () => void;
  children: ReactNode;
}
const Bloco = t0 => {
  const $ = _c(13);
  const {
    titulo,
    onEditar,
    children
  } = t0;
  let t1;
  if ($[0] !== titulo) {
    t1 = <span className="text-heading-dark text-base font-semibold">{titulo}</span>;
    $[0] = titulo;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FeatherEdit2 className="h-3.5 w-3.5" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onEditar) {
    t3 = <button type="button" onClick={onEditar} className="text-brand-600 flex items-center gap-1.5 text-[13px] font-semibold">{t2}Editar</button>;
    $[3] = onEditar;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <div className="flex items-center justify-between">{t1}{t3}</div>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== children) {
    t5 = <div className="grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2">{children}</div>;
    $[8] = children;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="flex flex-col gap-4 rounded-[16px] border border-solid border-neutral-200 p-6">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
const Campo = t0 => {
  const $ = _c(7);
  const {
    rotulo,
    valor
  } = t0;
  let t1;
  if ($[0] !== rotulo) {
    t1 = <span className="text-xs text-neutral-500">{rotulo}</span>;
    $[0] = rotulo;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = valor || "\u2014";
  let t3;
  if ($[2] !== t2) {
    t3 = <span className="text-heading-dark text-sm font-semibold">{t2}</span>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t3) {
    t4 = <div className="flex flex-col gap-0.5">{t1}{t3}</div>;
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export const RevisaoScreen = t0 => {
  const $ = _c(52);
  const {
    vm
  } = t0;
  const {
    form,
    planoSelecionado,
    cadastroErro,
    pagamentoErro
  } = vm;
  let t1;
  if ($[0] !== vm.stepperSteps) {
    t1 = <WizardHeader steps={vm.stepperSteps} />;
    $[0] = vm.stepperSteps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-3"><h1 className="text-heading-dark text-2xl font-semibold sm:text-[30px]">É assim que sua empresa vai notificar?</h1><p className="text-label-muted max-w-[420px] text-base leading-relaxed">Revise os dados antes de seguir para o pagamento. Você ainda pode ajustar qualquer informação.</p></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== cadastroErro) {
    t3 = cadastroErro && <AvisoFunil variante="erro">{cadastroErro}</AvisoFunil>;
    $[3] = cadastroErro;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== pagamentoErro) {
    t4 = pagamentoErro && <AvisoFunil variante="erro">{pagamentoErro}</AvisoFunil>;
    $[5] = pagamentoErro;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== vm) {
    t5 = () => vm.goTo("trocarPlano");
    $[7] = vm;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== planoSelecionado || $[10] !== vm.carregandoPlanos) {
    t6 = planoSelecionado ? <><Campo rotulo="Plano" valor={planoSelecionado.nome} /><Campo rotulo="Franquia mensal" valor={`${planoSelecionado.franquia} (${planoSelecionado.porEnvio})`} /><Campo rotulo="Total" valor={`${planoSelecionado.preco}${planoSelecionado.precoSufixo}`} /><Campo rotulo={"Ciclo de cobran\xE7a"} valor="Mensal" /></> : <Campo rotulo="Plano" valor={vm.carregandoPlanos ? "Carregando..." : ""} />;
    $[9] = planoSelecionado;
    $[10] = vm.carregandoPlanos;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <Bloco titulo="Plano selecionado" onEditar={t5}>{t6}</Bloco>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== vm) {
    t8 = () => vm.goTo("cadastro");
    $[15] = vm;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== form.cnpj) {
    t9 = <Campo rotulo="CNPJ" valor={form.cnpj} />;
    $[17] = form.cnpj;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== form.razaoSocial) {
    t10 = <Campo rotulo={"Raz\xE3o social"} valor={form.razaoSocial} />;
    $[19] = form.razaoSocial;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== form.nomeFantasia) {
    t11 = <Campo rotulo="Nome fantasia" valor={form.nomeFantasia} />;
    $[21] = form.nomeFantasia;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== form.telefone) {
    t12 = <Campo rotulo="Telefone principal" valor={form.telefone} />;
    $[23] = form.telefone;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== form.responsavelNome) {
    t13 = <Campo rotulo={"Nome completo do respons\xE1vel"} valor={form.responsavelNome} />;
    $[25] = form.responsavelNome;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== form.responsavelEmail) {
    t14 = <Campo rotulo={"E-mail do respons\xE1vel"} valor={form.responsavelEmail} />;
    $[27] = form.responsavelEmail;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t10 || $[30] !== t11 || $[31] !== t12 || $[32] !== t13 || $[33] !== t14 || $[34] !== t8 || $[35] !== t9) {
    t15 = <Bloco titulo="Dados cadastrais" onEditar={t8}>{t9}{t10}{t11}{t12}{t13}{t14}</Bloco>;
    $[29] = t10;
    $[30] = t11;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
    $[34] = t8;
    $[35] = t9;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t15 || $[38] !== t3 || $[39] !== t4 || $[40] !== t7) {
    t16 = <div className="flex flex-1 justify-center px-6 py-10 md:px-20 md:py-14"><div className="grid w-full max-w-[1280px] grid-cols-1 items-start gap-10 lg:grid-cols-[minmax(280px,1fr)_minmax(420px,1.85fr)] lg:gap-20">{t2}<div className="flex w-full flex-col gap-5">{t3}{t4}{t7}{t15}</div></div></div>;
    $[37] = t15;
    $[38] = t3;
    $[39] = t4;
    $[40] = t7;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== vm) {
    t17 = () => vm.goTo("cadastro");
    $[42] = vm;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== t17 || $[45] !== vm.confirmandoRevisao || $[46] !== vm.confirmarRevisao) {
    t18 = <WizardFooter onCancelar={t17} onConfirmar={vm.confirmarRevisao} confirmarLoading={vm.confirmandoRevisao} />;
    $[44] = t17;
    $[45] = vm.confirmandoRevisao;
    $[46] = vm.confirmarRevisao;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== t1 || $[49] !== t16 || $[50] !== t18) {
    t19 = <div className="flex min-h-screen w-full flex-col bg-white">{t1}{t16}{t18}</div>;
    $[48] = t1;
    $[49] = t16;
    $[50] = t18;
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  return t19;
};